<template>
    <div>
        <div :class="[ expandable ? 'panel--expand' : 'panel' ]">
            <div class="panel__header">
                <h2>
                    <i class="panel__header__icon icons icon-briefcase"></i>
                    <span>{{$t('dashboard.work_experience.title')}}</span>
                </h2>
            </div>

            <div class="panel__body" :class="{expanded}">
                <div v-if="!workExperienceItems.length" class="panel--empty">
                    <center>{{$t('dashboard.work_experience.no_experience')}}</center>
                </div>
                <div v-else class="panel__list">
                    <work-experience-item v-for="item in workExperienceItems" :key="item.id" :item="item" />
                </div>
            </div>

            <div v-if="expandable" class="panel__btn-expand" @click="togglePanelExpansion">
                <div v-if="expanded"><i class="icons icon-arrow-up"></i>{{$t('dashboard.work_experience.see_less')}}</div>
                <div v-else><i class="icons icon-arrow-down"></i>{{$t('dashboard.work_experience.see_all')}}</div>
            </div>
        </div>
        <work-experience-modal />
    </div>
</template>

<script>
    import Vue from 'vue';
    import { Component, Prop } from 'vue-property-decorator';
    import WorkExperienceItem from './WorkExperienceItem';
    import WorkExperienceModal from '@/components/modals/dashboard/WorkExperienceModal';
    import WorkExperience from '@/models/WorkExperience';

    @Component({
        components: {
            WorkExperienceItem,
            WorkExperienceModal,

        }
    })
    export default class WorkExperiencePanel extends Vue {
        name = 'work-experience-panel';
        expanded = false;

        get workExperienceItems() {
            return this.$store.state.profile.profile.job_functions || [];
        }

        togglePanelExpansion() {
            this.expanded = !this.expanded;
        }

        get expandable() {
            return this.workExperienceItems.length && this.workExperienceItems.length > 2;
        }
    }

</script>



// WEBPACK FOOTER //
// src/components/panels/profile/WorkExperiencePanel.vue